import React, { useEffect, useState } from 'react';
import styles from './products.module.scss';
import ProductList from "./productList";
import ProductCategory from "./productCategory";
import { KoTabs, KoForm, KoModal, KoButton, KoLoader} from 'packages';

import ProductCurd from './productList/curd';
import ProductStatus from './productList/productStatus';



export default function Products() {
  const [form] = KoForm.useForm();
  const [loading, setLoading] = useState(false);


  const [addProduct, setModalAddProduct] = useState(false);

  useEffect(()=>{
    setLoading(true);
    setLoading(false);
  }, []);


  return (
    <div className={`${styles.wrapper} profileSection`}>
      <ProductStatus />
      <KoTabs options={[
        { label: 'Products', key: 'Productlist', children: <ProductList /> },
        { label: 'Categories', key: 'Productcategory', children: <ProductCategory /> }
      ]} />
     
      <KoModal
        title={`Add Product`}
        centered
        afterClose={() => { form.resetFields();  }}
        open={addProduct}
        handleOk={() => { setModalAddProduct(false); }}
        onClose={() => { setModalAddProduct(false); form.resetFields(); }}
        width={'65vw'}
        maskClosable={false}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => { setModalAddProduct(false); form.resetFields(); }} />,
          <KoButton key='create' loading={loading} type='primary' label={`Create`}
            onClick={() => form.submit()} />
        ]
        }
      >
        {loading && <KoLoader circle={false} />}
        <ProductCurd/>
        

      </KoModal>


    </div>
  );
}
